<template>
  <v-container fluid class="nav-wrap pa-8">
    <!-- Header -->
    <v-row class="mb-8" align="center" justify="space-between">
      <v-col cols="12" md="6" class="d-flex align-center">
        <div class="title-badge mr-4">Portal Navigatsiyasi</div>
       
      </v-col>
    </v-row>

    <!-- Cards -->
    <v-row dense class="mx-auto portals-row" align="stretch" justify="flex-start">
      <v-col
        v-for="(p, idx) in portals"
        :key="p.title"
        cols="12"
        sm="6"
        md="4"
        class="d-flex mb-4 justify-end"
      >
        <v-card
          class="portal-card flex-grow-1"
          elevation="6"
          outlined
          :ripple="true"
          role="button"
          tabindex="0"
          @click="go(p.link)"
          @keyup.enter.native="go(p.link)"
          @keyup.space.native.prevent="go(p.link)"
        >
          <div class="card-top">
            <!-- <v-icon size="30" color="primary" class="mr-2">{{ p.icon }}</v-icon> -->
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-medium">{{ p.title }}</div>
              <div class="caption text--secondary one-line">{{ cleanHost(p.link) }}</div>
            </div>
          </div>

          <div class="card-body">
            <p class="mb-4 two-lines text--secondary">{{ p.description }}</p>

            <div class="meta">
              <div class="chip">{{ p.tag }}</div>
              <div class="chip alt">#{{ idx + 1 }}</div>
            </div>
          </div>

          <div class="card-actions">
            <v-btn block color="primary" depressed @click.stop="go(p.link)">
              Ochish <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Helper -->
    <v-row class="mt-8">
      <v-col cols="12" class="text--secondary caption d-flex align-center">
        <v-icon small class="mr-2">mdi-keyboard-outline</v-icon>
        Qisqa tugmalar: <strong class="mx-1">1</strong>, <strong class="mx-1">2</strong>, <strong class="mx-1">3</strong>, <strong class="mx-1">4</strong> — tegishli panelni ochadi
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PortalNavigation",
  data() {
    return {
      portals: [
        {
          title: "Admin Panel",
          link: "#", // app.usat.uz is no longer available
          description: "Boshqaruv, ro‘yxatlar va statistikalar",
          icon: "mdi-cog-outline",
          tag: "admin",
        },
        {
          title: "Test Parse",
          link: "https://test-parse.usat.uz/auth",
          description: "Imtihon testlari va parsing tizimi",
          icon: "mdi-file-document-edit-outline",
          tag: "test",
        },
        {
          title: "Student Profil",
          link: "https://my.usat.uz/sign-in",
          description: "Talaba shaxsiy kabineti (profil va natijalar)",
          icon: "mdi-account-circle-outline",
          tag: "student",
        },
        {
          title: "Kontrakt Panel",
          link: "https://contract.usat.uz/uz/login",
          description: "To‘lovlar va shartnomalarni boshqarish",
          icon: "mdi-cash-multiple",
          tag: "contract",
        },
      ],
    };
  },
  methods: {
    go(link) {
      window.open(link, "_blank", "noopener,noreferrer");
    },
    cleanHost(url) {
      try {
        const u = new URL(url);
        return u.host + u.pathname.replace(/\/$/, "");
      } catch (e) {
        return url;
      }
    },
    onKey(e) {
      // Modern, lint-safe key handling; no hasOwnProperty usage
      const idx = ["1", "2", "3", "4"].indexOf(e.key);
      if (idx !== -1 && this.portals[idx]) {
        this.go(this.portals[idx].link);
      }
    },
  },
  mounted() {
    window.addEventListener("keyup", this.onKey);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.onKey);
  },
};
</script>

<style scoped>
.nav-wrap {
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
  min-height: 100vh;
}

/* Header chip */
.title-badge {
  background: #eef2ff;
  color: #3b5bfd;
  border: 1px solid #dfe6ff;
  padding: 8px 12px;
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1;
}

/* Grid max-width */
.portals-row {
  max-width: 1280px;
  justify-content: flex-start;
}

/* Cards */
.portal-card {
  border-radius: 18px !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  border: 1px solid #edf1f7 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.portal-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 28px rgba(26, 35, 126, 0.08) !important;
  border-color: #dfe7fb !important;
}

.card-top {
  display: flex;
  align-items: center;
  padding: 18px 18px 8px 18px;
}
.card-body {
  padding: 0 18px 6px 18px;
  flex: 1 1 auto; /* makes bodies stretch evenly */
}
.card-actions {
  padding: 12px 18px 18px 18px;
}

/* Chips */
.meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.chip {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #3b5bfd;
  border: 1px solid #dde5ff;
  font-weight: 600;
}
.chip.alt {
  background: #f2f4f7;
  color: #6b7280;
  border-color: #e5e7eb;
}

/* Line clamps */
.one-line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.two-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Responsive tweaks */
@media (max-width: 960px) {
  .card-top {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (max-width: 600px) {
  .chip {
    font-size: 11px;
    padding: 3px 8px;
  }
}
</style>
